import { StatusFailedIcon as e } from "./StatusFailedIcon.js";
import { StatusCompletedIcon as t } from "./StatusCompletedIcon.js";
import { StatusBlockedByIcon as n } from "./StatusBlockedByIcon.js";
import { StatusBlockingIcon as r } from "./StatusBlockingIcon.js";
import { StatusCanceledIcon as i } from "./StatusCanceledIcon.js";
import { StatusInProgressIcon as a } from "./StatusInProgressIcon.js";
import { StatusInReviewIcon as o } from "./StatusInReviewIcon.js";
import { StatusNeedsAttentionIcon as s } from "./StatusNeedsAttentionIcon.js";
import { StatusScheduledIcon as c } from "./StatusScheduledIcon.js";
import { StatusToDoIcon as l } from "./StatusToDoIcon.js";
import { jsx as u } from "react/jsx-runtime";
//#region src/components/status-icons/StatusIcon.tsx
var d = {
	"to-do": l,
	scheduled: c,
	"in-progress": a,
	"in-review": o,
	completed: t,
	canceled: i,
	blocking: r,
	"blocked-by": n,
	failed: e,
	"needs-attention": s
}, f = ({ status: e, ...t }) => {
	let n = d[e];
	return /* @__PURE__ */ u(n, { ...t });
};
//#endregion
export { f as StatusIcon };
